import {IComponentOptions} from 'angular';

require('./dv-leistungsempfaenger.scss');

export class LeistungsempfaengerComponentConfig implements IComponentOptions {
    transclude = false;
    bindings: any = {
        inhaberName: '<',
        bankName: '<',
        iban: '<',

    };
    template = require('./dv-leistungsempfaenger.html');
    controller = DvLeistungsempfaengerController;
    controllerAs = 'vm';
    require: any = {parentForm: '?^form'};
}

export class DvLeistungsempfaengerController {
    static $inject = [];

    inhaberName: string;
    bankName: string;
    iban: string;

    /* @ngInject */
    constructor() {
    }

}




// WEBPACK FOOTER //
// ./src/app/core/component/dv-leistungsempfaenger/dv-leistungsempfaenger.ts